<template>
  <div>
    <mdb-tabs
      :active="0"
      @activeTab="onActiveTab"
      default
      :links="[
        { text: '개요'},
        { text: '훈련목표'},
        { text: '교과편성 총괄표'},
        { text: '훈련이수 체계도'},
        { text: '운영로드맵'},
        { text: '교과별 계획'}
      ]"/>
    <div class="p-4">
      <traing-overview v-if="active === 0" :training="training"/>
      <training-objective v-if="active === 1" :objective="training.objective"/>
      <training-structure v-if="active === 2" :trainingId="training._id"/>
      <div v-if="active === 3" >http://e-ncs.kr/api/file/image/archi/{{training.archi}}</div>
      <training-loadmap v-if="active === 4" :loadmap="training.loadMap"/>
      <subjects-plan v-if="active === 5" :trainingId="training._id"/>
    </div>
  </div>
</template>
<script>
import { mdbTabs } from 'mdbvue';
import TraingOverview from './TrainingOverview.vue';
import Training from '@/models/Training'
import TrainingObjective from './TrainingObjective.vue';
import TrainingLoadmap from './TrainingLoadmap.vue';
import TrainingStructure from './TrainingStructure.vue';
import SubjectsPlan from '@/components/subject/SubjectsPlan.vue';
export default {
  name: 'TrainingIntro',
  components: { mdbTabs, TraingOverview, TrainingObjective, TrainingLoadmap, TrainingStructure, SubjectsPlan },
  props: ['trainingId'],
  data: () => ({
    TAG: 'TRAINING_INTRO',
    training: new Training({ ncsTraining: {} }),
    active: 0
  }),
  computed: {
  },
  methods: {
    onActiveTab (index) {
      this.active = index
    }
  },
  watch: {
    async trainingId () {
      this.training = await this.$getTraining(this.trainingId)
      if (!this.training.ncsTraining) {
        this.training.ncsTraining = { name: '' }
      }
      // console.log('this.TAG', this.training)
    }
  }
}
</script>
